import {List, Map, fromJS} from 'immutable'

import {
  SET_NEW_MESSAGE,
  SET_PREVIOUS_MESSAGES,
  REMOVE_PREVIOUS_MESSAGES,
  UPDATE_MESSAGE_ATTR
} from '../action_types'

const injectKey = (message, key) => message.set('key', key)
const sortByTime = (message) => message.get('time')

const concatPreviousMessages = (prevMessages, state) => {
  const prevLastTime = prevMessages.getIn([prevMessages.size - 1, 'time'])
  const currentFirstTime = state.getIn([0, 'time'])

  if (!prevLastTime) return state
  if (!currentFirstTime) return prevMessages
  if (prevLastTime >= currentFirstTime) return state

  return List().concat(prevMessages, state)
}

const updateMessageAttribute = (state, messageId, attr, val) => {
  const index = state.findKey((message) => message.get('key') === messageId)

  if (!index || index < 0) return state

  if (attr === 'approvalStatus') return state.delete(index)

  return state.setIn([index, attr], val)
}

const messageListReducer = (state = List(), action) => {
  switch (action.type) {
    case SET_PREVIOUS_MESSAGES:
      const previousMessages = fromJS(action.messages)
        .map(injectKey)
        .toList()
        .sortBy(sortByTime)

      return concatPreviousMessages(previousMessages, state)

    case SET_NEW_MESSAGE:
      const newMessage = fromJS(action.message).merge({key: action.messageKey})

      return state.push(newMessage)

    case UPDATE_MESSAGE_ATTR:
      return updateMessageAttribute(state, action.messageId, action.attr, action.val)

    default:
      return state
  }
}

export default (state = Map({}), action) => {
  switch (action.type) {
    case REMOVE_PREVIOUS_MESSAGES:
      return state.set(action.containerId, List())

    case SET_PREVIOUS_MESSAGES:
       const updatedMessagesWithPrev = messageListReducer(
        state.get(action.containerId), action
      )
      return state.mergeDeep({[action.containerId]: updatedMessagesWithPrev})

    case SET_NEW_MESSAGE:
      const updatedMessagesWithNew = messageListReducer(
        state.get(action.containerId), action
      )

      return state.mergeDeep({[action.containerId]: updatedMessagesWithNew})

    case UPDATE_MESSAGE_ATTR:
      const updatedMessages = messageListReducer(
        state.get(action.containerId), action
      )

      return state.mergeDeep({[action.containerId]: updatedMessages})

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/messages.js
 **/